export const IOS_SCREENSHOT_DISPLAY_NAME = "Screenshot UI";
export const IOS_SCREENSHOT_ICON_SLUG = "screenshotui";

export function isIosScreenshotBundleId(
  appIdentifier?: string | null,
  displayName?: string | null,
): boolean {
  for (const value of [appIdentifier, displayName]) {
    const trimmed = (value ?? "").trim();
    if (!trimmed) continue;

    const lastSegment = trimmed.split(".").pop()?.toLowerCase() ?? "";
    if (lastSegment.includes("screenshot")) return true;
  }

  return false;
}
